module.exports = __webpack_public_path__ + "img/DSC0176.47d36ea3.jpg";